/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import { cache } from '@codegrade/utils';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export class ApiResultError extends Error {
    response;
    callbacks;
    originalError;
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    _notAnInterface;
    /** The error that occured. */
    error;
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    _onAfterError = new cache.Cache(() => this._makeCallback('onAfterError'));
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    _onError = new cache.Cache(() => this._makeCallback('onError'));
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    constructor(error, response, callbacks, message, originalError) {
        super(message);
        this.response = response;
        this.callbacks = callbacks;
        this.originalError = originalError;
        this.error = error;
        Object.freeze(this);
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    static fromResponse(error, response) {
        return new ApiResultError(error, response, [], error.message, error);
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    toString() {
        const status = this.response.status.toString(10);
        const error = this.error.toString();
        return `ApiResultError(${status}, ${error})`;
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    _makeCallback(callback) {
        const callbacks = this.callbacks;
        return async function _makeCallbackResult() {
            for (const meths of callbacks) {
                const meth = meths[callback];
                if (meth != null) {
                    // eslint-disable-next-line no-await-in-loop
                    await meth.bind(this)(this);
                }
            }
        };
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    get onAfterError() {
        return this._onAfterError.v;
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    get onError() {
        return this._onError.v;
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    addCallbacks(...methods) {
        return new ApiResultError(this.error, this.response, [...this.callbacks, ...methods], this.message, this.originalError);
    }
    /**
     * Maps this ApiResultError to another type of ApiResultError.
     *
     * @param mapper The function used to map this error.
     * @returns The new ApiResultError.
     */
    map(mapper) {
        return new ApiResultError(mapper(this.error), this.response, this.callbacks, this.message, this.originalError);
    }
}
